<template>
<BlockConfig title="Tabella misure"
    :valid="valid"
    @handleSave="handleSave"
    @restore="restore">
    <v-form v-model="valid">
        <div class="d-flex my-2">
            <v-text-field dense outlined
                label="nome prova*"
                :rules="[rules.mandatory]" 
                v-model="config_data.title"
            ></v-text-field>
            <v-text-field dense outlined
                v-model="config_data.min_readings"
                class="ml-2"
                :rules="[rules.mandatory]" 
                label="misure minime*"
            />
        </div>
        <div>
            <v-label>etichette tabella<span class="caption"> - (ordine fisso)</span></v-label>
            <div class="d-flex mt-2 flex-wrap">
                <v-text-field dense outlined label="n" placeholder="" :rules="[rules.mandatory]" v-model="config_data.headers.count"></v-text-field>
                <v-text-field dense outlined label="massa" placeholder="" :rules="[rules.mandatory]" v-model="config_data.headers.mass"></v-text-field>
                <v-text-field dense outlined label="indicazione" placeholder="" :rules="[rules.mandatory]" v-model="config_data.headers.reading"></v-text-field>
                <v-text-field dense outlined label="errore" placeholder=""  required :rules="[rules.mandatory]" v-model="config_data.headers.difference"></v-text-field>
                <v-text-field dense outlined label="errore formattato" placeholder=""  required :rules="[rules.mandatory]" v-model="config_data.headers.toleranceError"></v-text-field>
                <v-text-field dense outlined label="accettabilità" placeholder=""  required :rules="[rules.mandatory]" v-model="config_data.headers.tolerance"></v-text-field>
                <v-text-field dense outlined label="Risultato" placeholder="" :rules="[rules.mandatory]" v-model="config_data.headers.result"></v-text-field>
            </div>
        </div>
    </v-form>
</BlockConfig>
</template>
<script>
import {ConfigMixin} from '../../../utils/configMixin_new'
import BlockConfig from '../../../components/utils/BlockConfig'

export default {
    components: {BlockConfig},
    mixins: [ConfigMixin],
    data() {
        return {
            o_data: {
                title: this.data.block.label,
                min_readings: 5,
                hi_res: 'off',
                zero_device: 'out',
                headers: {
                   'count': 'n',
                   'mass':'massa',
                   'reading': 'indicazione',
                   'difference': 'errore',
                   'toleranceError': 'errore formattato',
                   'tolerance': 'accettabilità',
                   'result': 'risultato'
                }
            },
        }
    },
    
}
</script>    